import { render, staticRenderFns } from "./bunkersOnTableCEV.vue?vue&type=template&id=66c43146&scoped=true"
import script from "./bunkersOnTableCEV.vue?vue&type=script&lang=js"
export * from "./bunkersOnTableCEV.vue?vue&type=script&lang=js"
import style0 from "./bunkersOnTableCEV.vue?vue&type=style&index=0&id=66c43146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c43146",
  null
  
)

export default component.exports